export async function copyToClipboard(text: string) {
  if (window?.navigator?.clipboard) {
    return window.navigator.clipboard.writeText(text);
  }
}
